import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let instance: ApplicationInsights | undefined;

/**
 * Initialise the browser-side Application Insights SDK.
 *
 * Returns the singleton `ApplicationInsights` instance, or `undefined`
 * when no connection string is configured (local dev).
 *
 * Safe to call multiple times — only the first call creates the instance.
 */
export function initFrontendAppInsights(
  connectionString: string | undefined,
): ApplicationInsights | undefined {
  if (instance) {
    return instance;
  }

  if (!connectionString) {
    return undefined;
  }

  instance = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
      // Header tracking captures request/response headers wholesale —
      // including cookies and any custom auth headers. Keep off; URL +
      // status + duration is enough for the dependency view.
      enableRequestHeaderTracking: false,
      enableResponseHeaderTracking: false,
      disablePageUnloadEvents: ['unload'],
    },
  });

  instance.loadAppInsights();
  instance.trackPageView(); // initial page view

  return instance;
}

/**
 * Returns the singleton frontend Application Insights instance.
 * `undefined` when telemetry is not configured.
 */
export function getFrontendAppInsights(): ApplicationInsights | undefined {
  return instance;
}

/** Reset for testing purposes only */
export function _resetFrontendAppInsights(): void {
  instance = undefined;
}
